import styled from 'styled-components'

type Props = {
	isHighlighted: boolean
}

export const IconWrapper = styled.div<Props>`
	height: 73px;
	width: 73px;
	border-radius: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme, isHighlighted }) => (isHighlighted ? theme.color.textContrast : theme.color.iconBackgroundHighlighted)};
	background-color: ${({ theme, isHighlighted }) => (isHighlighted ? theme.color.primary : theme.color.iconBackground)};
	border: 9px solid ${({ theme }) => theme.color.cardBackground};
	flex-shrink: 0;
	z-index: 1;

	> svg {
		height: 32px;
		width: 32px;
	}
`
